import Vue from 'vue'
import './plugins/vuetify'

import App from './App.vue'
import router from './router'
import store from './store'

import './mixins/GlobalMixin'

Vue.config.productionTip = false

if (process.env.VUE_APP_DEBUG === 'true') {
  // eslint-disable-next-line no-console
  console.warn('vue debug mode enabled')
  Vue.config.devtools = true
  Vue.config.debug = true
  Vue.config.silent = false
  Vue.config.performance = true
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
